import { Link } from 'react-router-dom';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import {
  StyledSectionSummary,
  StyledSectionSummaryContent,
  StyledSectionSummaryTitle,
  StyledSectionSummaryDescription,
  StyledSectionSummaryCta,
  StyledSectionSummaryFeatured,
} from './SectionSummary.styles';

export interface SectionSummaryProps {
  id: string;
  title: string;
  description: string;
  ctaLabel: string;
  ctaHref: string;
  featuredItems?: React.ReactNode;
  background?: 'default' | 'muted';
}

export const SectionSummary = ({
  id,
  title,
  description,
  ctaLabel,
  ctaHref,
  featuredItems,
  background = 'default',
}: SectionSummaryProps) => {
  /* The band is the observee, so triggerOnce fires the sequence as it starts to enter the viewport
     and every band keeps the same vocabulary as the Hero's own reveal. Where the API is missing the
     hook already reports visible, which is why the tests need no stub. */
  const { ref, isIntersecting } = useIntersectionObserver<HTMLElement>();

  return (
    <StyledSectionSummary
      ref={ref}
      id={id}
      $background={background}
      aria-label={title}
    >
      <StyledSectionSummaryContent>
        <StyledSectionSummaryTitle $visible={isIntersecting} as="h2">
          {title}
        </StyledSectionSummaryTitle>
        <StyledSectionSummaryDescription $visible={isIntersecting} as="p">
          {description}
        </StyledSectionSummaryDescription>
        <StyledSectionSummaryCta $visible={isIntersecting} as={Link} to={ctaHref}>
          {ctaLabel}
        </StyledSectionSummaryCta>
        {featuredItems && (
          <StyledSectionSummaryFeatured>
            {featuredItems}
          </StyledSectionSummaryFeatured>
        )}
      </StyledSectionSummaryContent>
    </StyledSectionSummary>
  );
};
